<template>
  <v-content>
    <v-layout>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn style="float: right;" :color="Theme.PINK" dark :disabled="list.length >=6" @click.prevent="addNew">新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <product-type-detail :visible="editView.visible"
                         :item-detail="editView.item"
                         :show-cancel="editView.showCancel"
                         @cancelEvent="editView.cancelEvent"
                         @confirmEvent="editView.confirmEvent"/>
  </v-content>
</template>

<script>
import TableView from "@/components/TableView";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import {getUUId} from "@/utils/tools";
import ProductTypeDetail from "@/pages/product/productTypeDetail";
export default {
  name: "productType",
  components:{
    ProductTypeDetail,
    TableView
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters([]),
    getColumnKeys(){
      return [
        { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        { value:'title', text:'主分類', sortable: true },
        { value:'subTypeList', text:'子分類', sortable: false, tags: true, },
        { value:'sort', text:'排序', sortable: true,},
        { value:'delete', text:'刪除' , isEvent: true, color: this.Theme.YELLOW, sortable: false },
      ]
    }
  },
  methods: {
    ...mapActions(['getTypeList', 'removeTypeInfo']),
    async loadData(){
      const res = await this.getTypeList({});
      if (res.data.statusCode === 0) {
        const types = res.data.data;
        this.list = [];
        for (let type of types){
          this.list.push(type)
        }
        this.pagination.totalItems = this.list.length;
        console.log(`getTypeList == ${JSON.stringify(this.list)}`)
      }
    },
    changePage(page){
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1){
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell) {
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'delete') {
        this.showAlert({
          title: '提示',
          content: '刪除大分類將會自動把此分類的商品下架，是否確定要刪除？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          }
        });
      } else {
        this.editView.title = cell.key === 'add' ? '新增商品':'修改商品'
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
      }
    },
    async deleteEvent(item){
      const res = await this.removeTypeInfo({
        typeId: item.typeId,
      });

      if (res.data.statusCode === 0){
        this.loadData();
      }
    },
    addNew(){
      this.cellEvent({
        key: 'add',
        item: {
          typeId: getUUId(),
          title:'',
          sort: 0,
          subTypeList:[],
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
